module.exports = __webpack_public_path__ + "static/media/print.764c477b.png";